/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { t } from "i18next";

function Breadcrumbs({ icon, title, route, light,type }) {
 const routes = route[0];

 //console.log('console...................');
// console.log(routes);
//routes.reverse();
 //console.log(routes);

//const routesReverse =routes.reverse();
 //console.log('after reverse');
 // console.log(routesReverse);


const routesReverse = [];
routes.forEach(element => {
    routesReverse.unshift(element)
 });


  return (
    <MDBox mr={{ xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}
      >
        


   
   {routesReverse.map((el) => (

    (el.name)?
          <Link to={(el.name=='All' && type ==1)?'/productcollection/list':
          (el.name=='All' && type ==2)?'/servicecollection/list'
          :
          (type==1)?'/productcollection/list/'+el.id:'/servicecollection/list/'+el.id} key={el}>
            <MDTypography
              component="span"
              variant="button"
              fontWeight="regular"
              textTransform="capitalize"
              color={light ? "white" : "dark"}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
             {(el.name=='All' && type==1)? t('All'):
             (el.name=='All' && type==2)? t('All'):
             el.name}
            
            </MDTypography>
          </Link>
          :null
        ))} 



      
     
      </MuiBreadcrumbs>
   
    </MDBox>
  );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;